import Vue from 'vue';
import Router from '@/router';
import * as types from '../mutation-types';


// initial state
const state = {
  refs: [],
  ref: {},
  slide: 0,
  tempRefs: [],
  voteBusy: false,
  uploaded: false,
  voteCounter: 0,
};

// getters
const getters = {
  voteCounter: stateFreezed => stateFreezed.voteCounter,
  voteBusy: stateFreezed => stateFreezed.voteBusy,
  slide: stateFreezed => stateFreezed.slide,
  tempRefs: stateFreezed => stateFreezed.tempRefs,
  refs: stateFreezed => stateFreezed.refs,
  ref: stateFreezed => stateFreezed.ref,
  uploaded: stateFreezed => stateFreezed.uploaded,
};

// actions
const actions = {
  fetchNewRefs({ commit, dispatch }, params) {
    commit(types.CLEAR_REF);
    if (params.person.id) {
      Vue.http.get(`refs/?estimator_exclude=${params.person.id}&random&tag=${params.slug}`)
      .then((response) => {
        if (response.body) {
          if (response.body.count === 0 || response.body.count < 3) {
            dispatch('fetchRefs', params);
          } else {
            commit(types.RECEIVE_REFS, response.body);
          }
        }
      });
    } else {
      Router.push('/');
    }
  },
  fetchRefs({ commit }, params) {
    commit(types.CLEAR_REF);
    Vue.http.get(`refs/?random&tag=${params.slug}`)
    .then((response) => {
      if (response.body) {
        commit(types.RECEIVE_REFS, response.body);
      }
    });
  },
  voteRef({ commit }, params) {
    Vue.http.post(`refs/${params.ref.id}/estimate/`, { value: params.value }, { emulateJSON: true })
    .then(() => {
      commit(types.VOTE_COUNTER, params.value);
    });
  },
  voteRefs() {
    if (state.tempRefs && state.tempRefs.length > 2) {
      for (let r = 0; r < state.tempRefs.length; r += 1) {
        const params = state.tempRefs[r];
        if (params && params.ref && params.ref.id) {
          Vue.http.post(`refs/${params.ref.id}/estimate/`, { value: params.value }, { emulateJSON: true });
        }
      }
    }
  },
  changeTagRef({ commit }, params) {
    Vue.http.put(`refs/${params.id}/`, JSON.stringify({ tags: [params.tags] }), { emulateJSON: true });
  },
  createImage({ commit }, formData) {
    Vue.http.post('/api/refs/upload/', formData)
    .then(() => {
      commit(types.IMAGE_UPLOADED);
    });
  },
  deleteImage({ commit }, ref) {
    Vue.http.delete(`refs/${ref.id}/`);
  },
};

// mutations
const mutations = {
  [types.RECEIVE_REFS](stateFreezed, refs) {
    const st = stateFreezed;
    st.voteCounter = 0;
    st.slide = 0;
    st.refs = refs;
  },
  [types.FETCH_REF](stateFreezed, ref) {
    const st = stateFreezed;
    st.ref = ref;
  },
  [types.UPDATE_REF](stateFreezed, params) {
    const st = stateFreezed;
    st.refs[params.key] = params.value;
  },
  [types.CLEAR_REF](stateFreezed) {
    const st = stateFreezed;
    st.tempRefs = [];
    st.refs = [];
  },
  [types.TEMP_REF](stateFreezed, ref) {
    const st = stateFreezed;
    Vue.set(st.tempRefs, st.slide, ref);
  },
  [types.VOTE_SLIDE](stateFreezed, number) {
    const st = stateFreezed;
    st.slide = number;
  },
  [types.VOTE_COUNTER](stateFreezed, dir) {
    const st = stateFreezed;
    if (st.refs && st.refs.results) {
      st.tempRefs[st.slide].dir = dir;
      if (st.voteCounter === st.slide) {
        st.slide += 1;
        st.voteCounter += 1;
      } else {
        st.slide = st.voteCounter;
      }
    }
  },
  [types.VOTE_BUSY](stateFreezed, busy) {
    const st = stateFreezed;
    st.voteBusy = busy;
  },
  [types.INCREASE_COUNTER](stateFreezed) {
    const st = stateFreezed;
    st.voteCounter += 1;
    st.slide = st.voteCounter;
  },
  [types.IMAGE_UPLOADED](stateFreezed) {
    const st = stateFreezed;
    st.uploaded = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/refs.js